import(/* webpackMode: "eager" */ "/codebuild/output/src999447862/src/ihs-web-app/apps/web/src/app/(navbar)/discussions/page.tsx");
